import dynamic from 'next/dynamic';

import { HotelOverviewComponentProps } from './HotelOverview.types';

export const HotelOverview = dynamic<HotelOverviewComponentProps>(() =>
  import('./HotelOverview').then(module => module.HotelOverview)
);
